import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as RouterActions from '../../../actions/RouterActions';
import { Icon, Button, Form } from 'semantic-ui-react'
import _ from 'lodash';

export function Mapping(props){

    const [isEditMode, setEditMode] = useState(false);
    const [mapping, setMapping] = useState(null);

    useEffect(() => {
        setMapping(_.cloneDeep(props.mapping));
    }, [props.mapping]);

    useEffect(() => {
        if(typeof props.editMode !== 'undefined' && props.editMode !== null)
            setEditMode(props.editMode);
        
    }, [props.editMode]);

    useEffect(() => {
        if(isEditMode && mapping === null)
            setMapping([]);
        else if(!isEditMode && mapping !== null){
            if(mapping.length > 0){
                let copy = _.cloneDeep(mapping);

                copy = _.filter(copy, (entry) => {
                    if(typeof entry.type === 'undefined')
                        entry.type = 'static';
                    if(entry.type === 'static'){
                        if(entry.value.length === 0)return false;
                        if(typeof entry.path !== 'undefined')delete entry.path;
                    }else if(entry.type === 'path'){
                        if(entry.path.length === 0)return false;
                        if(typeof entry.value !== 'undefined')delete entry.value;
                    }
                    return true;
                });

                if(copy.length === 0)
                    props.onChange(null);
                else{
                    console.log('Call on change');
                    props.onChange(copy);
                }
            }else{
                props.onChange(null);
            }
        }
    }, [isEditMode]);

    if(isEditMode && mapping !== null && (mapping.length === 0 || (
            (mapping[mapping.length - 1].type === 'path' && (typeof mapping[mapping.length - 1].path !== 'undefined' && mapping[mapping.length - 1].path.length > 0))
            || (mapping[mapping.length - 1].type === 'static' && (typeof mapping[mapping.length - 1].value !== 'undefined' && mapping[mapping.length - 1].value.length > 0))
    ))){
        setMapping([...mapping, {
            type: 'static',
            value: ''
        }]);
    }

    const setValue = (idx, val) => {
        let copy = _.cloneDeep(mapping);

        if(typeof copy[idx].type === 'undefined' || copy[idx].type === 'static')
            copy[idx].value = val;
        else
            copy[idx].path = val;
        
        setMapping(copy);
    };

    const setTranslate = (idx, enabled) => {
        let copy = _.cloneDeep(mapping);

        copy[idx].translate = enabled;
        
        setMapping(copy);
    };

    const setType = (idx, type) => {
        let copy = _.cloneDeep(mapping);

        if(typeof copy[idx].type === 'undefined' || copy[idx].type === 'static')
            copy[idx].path = copy[idx].value;
        else
            copy[idx].value = copy[idx].path;

        copy[idx].type = type;
        
        setMapping(copy);
    };

    return (
        <div>
        {
            (typeof mapping === 'undefined' || mapping === null)?
                <div style={{'font-style': 'italic'}}>standard</div>
            :
                mapping.map((entry, idx) => (
                    isEditMode?
                        <div style={{display: 'flex', marginTop: (idx > 0)?'0.3em':0}}>
                            <Button size="mini" onClick={(e) => setType(idx, (typeof entry.type !== 'undefined' && entry.type !== 'static')?'static':'path')} icon={(typeof entry.type === 'undefined' || entry.type === 'static')?'paperclip':'chain'} active={(typeof entry.type !== 'undefined' && entry.type !== 'static')} /> 
                            <Button size="mini" onClick={(e) => setTranslate(idx, !(typeof entry.translate !== 'undefined' && entry.translate))} icon="translate" active={(typeof entry.translate !== 'undefined' && entry.translate !== false)} /> 

                            <Form.Field style={{
                                flexGrow: 1
                            }} size="mini">
                                <input value={(entry.type === 'static')?entry.value:entry.path} onChange={(e) => {
                                    setValue(idx, e.target.value);
                                }}/>
                            </Form.Field>
                        </div>
                    :
                        <div>
                            <Icon name={(entry.type === 'static')?'paperclip':'chain'} /> 

                            {(entry.type === 'static')?entry.value:entry.path}

                            {
                                (typeof entry.translate !== 'undefined' && entry.translate)?
                                    <Icon name="translate" style={{
                                        marginLeft: '0.5em'
                                    }} /> 
                                :null
                            }
                        </div>
                ))
        }
        {
            isEditMode?
                <Button onClick={(e) => {
                    if(typeof props.onSetEditMode !== 'undefined')
                        props.onSetEditMode(false);
                    else
                        setEditMode(false);
                }} icon labelPosition="left" fluid style={{
                    marginTop: '0.5em'
                }}><Icon name="close" /> Schließen</Button>
            :
                <a onClick={(e) => {
                    if(typeof props.onSetEditMode !== 'undefined')
                        props.onSetEditMode(true);
                    else
                        setEditMode(true);
                }} style={{
                    cursor: 'pointer'
                }}>Bearbeiten</a>
        }
        </div>
    )
}